import React, { useState } from "react";
import { FormControl, InputGroup } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faSave } from "@fortawesome/free-solid-svg-icons";

const CustomStatusCell = ({ initialValue, onSave }) => {
  const [value, setValue] = useState(initialValue || "");
  const [isEditing, setIsEditing] = useState(false);

  const handleSave = () => {
    onSave(value);
    setIsEditing(false);
  };

  return (
    <div style={{ minWidth: "140px", maxWidth: "200px" }}>
      {!isEditing ? (
        <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 10px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb", // light gray border
    background: "#fafafa",
    fontSize: "14px",
    transition: "all 0.2s ease",
  }}
  title={value}
  onMouseEnter={(e) => (e.currentTarget.style.background = "#f3f4f6")}
  onMouseLeave={(e) => (e.currentTarget.style.background = "#fafafa")}
>
  {/* Text gets ellipsis */}
  <span
    className={!value ? "text-muted" : ""}
    style={{
      flex: 1,
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      marginRight: "8px",
    }}
  >
    {value || "—"}
  </span>

  {/* Icon stays visible */}
  <FontAwesomeIcon
    icon={faPencilAlt}
    style={{ cursor: "pointer", color: "#6b7280", flexShrink: 0 }}
    onClick={() => setIsEditing(true)}
  />
</div>

      ) : (
        <InputGroup size="sm" style={{ borderRadius: "8px", overflow: "hidden" }}>
          <FormControl
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSave()}
            style={{
              border: "1px solid #d1d5db",
              borderRight: "none",
              fontSize: "14px",
              padding: "6px 10px",
              borderRadius: "8px 0 0 8px",
            }}
          />
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 12px",
              cursor: "pointer",
              background: "#3b82f6", // SaaS-blue primary
              color: "white",
              borderRadius: "0 8px 8px 0",
              transition: "background 0.2s ease",
            }}
            onClick={handleSave}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#2563eb")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#3b82f6")}
          >
            <FontAwesomeIcon icon={faSave} />
          </span>
        </InputGroup>
      )}
    </div>
  );
};

export default CustomStatusCell;
